export const initialState = {
  personalize: false,
  cardOrientation: 'playing-cards',
  perPage: 2,
  sections: [],
  addImage: false,
  treeKiller: false,
  displayEquipment: true,
  succinctAbilities: false,
  succinctActions: false,
  referenceSheet: false,
  factionRules: false,
  coreRules: false,
  weaponsRef: false,
  showRules: false,
  paperSize: 'A4',
  pageOrientation: ''
};

export function reducer(state, action) {
  switch (action.type) {
    case 'addImage':
      return {
        ...state,
        addImage: action.payload
      }
    case 'factionRules':
      return {
        ...state,
        factionRules: action.payload
      }
    case 'coreRules':
      return {
        ...state,
        coreRules: action.payload
      }
    case 'weaponsRef':
      return {
        ...state,
        weaponsRef: action.payload
      }
    case 'pageOrientation':
      return {
        ...state,
        pageOrientation: action.payload
      }
    case 'paperSize':
      return {
        ...state,
        paperSize: action.payload
      }
    case 'showRules':
      return {
        ...state,
        showRules: action.payload
      }
    case 'referenceSheet':
      return {
        ...state,
        referenceSheet: action.payload
      }
    case 'succinctActions':
      return {
        ...state,
        succinctActions: action.payload
      }
    case 'succinctAbilities':
      return {
        ...state,
        succinctAbilities: action.payload
      }
    case 'displayEquipment':
      return {
        ...state,
        displayEquipment: action.payload
      }
    case 'sections':
      return {
        ...state,
        sections: action.payload
      }
    case 'cardOrientation':
      return {
        ...state,
        cardOrientation: action.payload,
        addImage: action.payload === 'playing-cards',
        perPage: action.payload === 'horizontal' ? 2 : 4
      }
    case 'perPage':
      if (state.treeKiller) {
        return {
          ...state,
          perPage: state.cardOrientation === 'horizontal' ? 1 : 2
        }
      } else {
        return {
          ...state,
          perPage: action.payload
        }
      }
    case 'personalize':
      return {
        ...state,
        personalize: action.payload
      }
    case 'treekiller':
      if (action.payload) {
        return {
          ...state,
          treeKiller: action.payload,
          perPage: state.cardOrientation === 'horizontal' ? 1 : 2
        }
      } else {
        return {
          ...state,
          treeKiller: action.payload,
          perPage: state.cardOrientation === 'horizontal' ? 2 : 4
        }
      }
    default:
      return state
  }
}